<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        header: 'ID Searches',
        body: [
          `ID searches will perform a SQL search for the identifier provided against the 
          Master and Crosswalk tables`,
          `The user can filter the results. Drilling into the result data takes the user 
          to the Person Information page. 
          The user can also Add a New Person by clicking the + plus sign on the Search 
          Results panel.`,
        ],
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
</style>
